import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog , MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import CONFIG from '../../../config';
import { BackendService } from '../../shared/backend.service';
import { AuthService } from '../../shared/auth.service';
import { NotificationService } from '../../notification/notification.service';
import { NgForm, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Utilities } from '../../shared/utilities.service';
import { Location } from '@angular/common';
import { AlertmessageService } from 'app/shared/alertmessage.service';
import { Router } from '@angular/router';


@Component({
  selector: 'app-confirmmodify',
  templateUrl: './confirmmodify.component.html',
  styleUrls: ['./confirmmodify.component.scss']
})
export class ConfirmModifyComponent extends Utilities implements OnInit {

  passwordConfirmed: boolean = true;
  submitted: boolean = false;
  updatedProfile: FormGroup;


  constructor(
    public backendService: BackendService,
    public notificationService: NotificationService,
    public authService: AuthService,
    public location: Location,
    public dialog: MatDialog,
    public alert:AlertmessageService,
    public _router:Router,
    @Inject(MAT_DIALOG_DATA) public data: any) 
   { super(location, notificationService, authService, backendService)};

  ngOnInit() {
    console.log(this.data);
  }
  no() {
    this.dialog.closeAll();
    this._router.navigate(['/dashboard/account-setting']);
    //console.log(updatedProfile[updatedProfile] , this.passwordConfirmed);
  }
  accept() {
    
    this.updateProfile(this.data);
    this.dialog.closeAll();
    
  }
  updateProfile(updatedProfile) {
    console.log(updatedProfile['updatedProfile'] , this.passwordConfirmed);
    this.submitted = true;
    //console.log(this.updatedProfile.valid , this.passwordConfirmed);
    if (updatedProfile['updatedProfile'] && this.passwordConfirmed) {
      console.log('entered into method');
        this.backendService.putData(updatedProfile['updatedProfile'], `${CONFIG.profileApiUrlBase}/${btoa(this.authService.CustomerID)}`)
            .subscribe(
            response => {
               if(response['result'])
               {
                this.submitted = false;
                this.notificationService.showNotification({ message: response['msg'], type: 'success' });
                this.authService.logout();
              }
              // else
            ////  {
              //   this.alert.openConfirmationDialog(response['msg'],response['result']);
              //           this._router.navigate(['/dashboard/account-setting']);
              // }
            },
            error => {
                this.serverErrorOrTimeout(error);
            });
    } else {
       // validators handle this case
       console.log('error with form');
   }
  }

//   rejectConfirm(key) {
//        key=key+"_rejected";
//             this.backendService.putData(key, `${CONFIG.contactUsApiUrlBase}/${key}`)
//                 .subscribe(response => {
//                   //  this.submitted = false;
//                     if (response) {
//                         this.notificationService.showNotification({ message: response['msg'], type: 'success' });
                     
//                     } else {
//                         this.notificationService.showNotification({ message: response['msg'], type: 'error' });
//                     }
//                 },
//                 error => {
//                     this.serverErrorOrTimeout(error);
              
//              });
               
// }
}
